<div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-2">
  <h2>{{ infoIniciativas.title }}</h2>
  <div class="link-crear" *ngIf="infoIniciativas.linkProponer">
    <a [href]="infoIniciativas.linkProponer" target="_blank"><span>Proponer una
        iniciativa!</span><span>&rarr;</span></a>
  </div>
</div>

<p>{{ infoIniciativas.description }}</p>

<section class="filters-section">
  <div class="filters-container shadow">
    <form [formGroup]="filtroUI" (ngSubmit)="filtrar(false)">
      <label for="ordenPor">Ordenar por:</label>

      <div class="d-flex flex-wrap gap-3 w-100">
        <form-group appearance="outline">
          <select formControlName="ordenPor" class="form-select">
            <option value="nombre" selected>Nombre</option>
            <option value="id">Fecha de creacion</option>
          </select>
        </form-group>

        <form-group appearance="outline">
          <select formControlName="ordenDireccion" class="form-select">
            <option value="asc" selected>Ascendente</option>
            <option value="desc">Descendente</option>
          </select>
        </form-group>


      </div>
      <div class="filters-actions">
        <button type=" submit" class="btn btn-primary">Filtrar</button>
      </div>
    </form>
  </div>
</section>

<div *ngIf="elementos$.length > 0" class="container d-flex flex-wrap justify-content-between gap-1">
  <article class="col-5 mb-4" *ngFor="let elemento of elementos$">
    <a class="card-iniciativa" routerLink="iniciativas/{{ elemento.id }}">
      <div class="">
        <div class="logo">
          <img *ngIf="elemento['listadoImage']" src="{{ img_base }}{{ elemento['listadoImage'] }}"
            alt="{{ elemento.nombre }}" />
          <img *ngIf="!elemento['listadoImage']" src="assets/img/imgs/default.webp" alt="{{ elemento.nombre }}" />
        </div>
        <div class="info">
          <h4 class="fs-5 text-center mt-1">{{ elemento.nombre }}</h4>
          <p>{{ elemento.copete }}</p>
        </div>
      </div>
    </a>
  </article>
</div>

<div class="w-100 d-flex justify-content-center align-items-center p-3">
  <button *ngIf="this.elementos$.length < totalItems" class="load-more" (click)="filtrar(true)">
    Cargar más
  </button>
</div>